import { exec, getApiToken } from '../utils';
import type {
  GetRepairsArgs,
  GetRepairsExecVariables,
  GetRepairsExecResponse,
  RepairTableViewType,
} from '@src/types';

/**
 * Fetches paginated list of repairs with filtering and sorting
 * Automatically exchanges JWT for badge token if needed
 * @param args - Query parameters for fetching repairs
 * @returns Promise resolving to repair table view data
 */
export const getRepairs = async (
  args: GetRepairsArgs
): Promise<RepairTableViewType> => {
  const { token } = sessionStorage;

  const apiToken = await getApiToken(token);

  const variables: GetRepairsExecVariables = {
    ...args,
    token: apiToken,
  };

  const searchQuery = `
    query getRepairs(
      $partnerCode: String!
      $repairAttributes: RepairAttributeInputRestUserType
      $sortColumn: String
      $sortDirection: String
      $initiatedAfter: String
      $initiatedBefore: String
      $state: String
      $token: String!
      $pageSize: Int
      $page: Int
      $searchQuery: String
    ) {
      restUser(token: $token) {
        repairs(
          partnerCode: $partnerCode
          sortColumn: $sortColumn
          sortDirection: $sortDirection
          initiatedAfter: $initiatedAfter
          initiatedBefore: $initiatedBefore
          repairAttributes: $repairAttributes
          state: $state
          pageSize: $pageSize
          page: $page
          searchQuery: $searchQuery
        ) {
          page
          pageCount
          entries {
            uuid
            uuidPrefix
            status
            types
            customerName
            customerEmail
            dateInitiated
            dateUpdated
          }
        }
      }
    }
  `;

  const data = await exec<GetRepairsExecVariables, GetRepairsExecResponse>(
    searchQuery,
    {
      variables,
    }
  );

  return data.restUser.repairs;
};
